import type { Moment } from 'moment'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${(props) => props.theme.font.primary.weight.regular};
  font-size: ${rem(14)};
  line-height: ${rem(24)};
`

type Props = {
  title: string
  date?: Moment
  time?: Moment
  day?: number
}

function DateTimeBlock({ title, date, time, day }: Props) {
  const intl = useIntl()
  const timeFormat = useRegionTimeFormat()

  if (!date && !time && !day) return null

  const dayLabel = intl.formatMessage(
    {
      id: 'U/s7hc6hrq',
      defaultMessage: 'Day {day}',
      description: 'Day number label in trip itinerary',
    },
    { day },
  )

  return (
    <DateTime>
      <BodyText variant="medium" weight="bold">
        {title}
      </BodyText>
      {day && <BodyText variant="large">{dayLabel}</BodyText>}
      {!day && date && (
        <BodyText variant="large">
          {date?.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
        </BodyText>
      )}
      {time && <BodyText variant="large">{time?.format(timeFormat)}</BodyText>}
    </DateTime>
  )
}

export default DateTimeBlock
